import { getLocale } from "@travily/i18n";

const cache = new Map<string, Intl.DisplayNames>();

/**
 * Cached `Intl.DisplayNames` keyed by locale + type (e.g. "region", "language").
 * Constructing `Intl.DisplayNames` is relatively expensive, so instances are
 * memoised and shared across the region/language name helpers.
 */
export function getDisplayNames(type: Intl.DisplayNamesType, locale: string = getLocale()): Intl.DisplayNames {
  const key = `${locale}:${type}`;
  let instance = cache.get(key);
  if (!instance) {
    instance = new Intl.DisplayNames([locale], { type });
    cache.set(key, instance);
  }
  return instance;
}
